/**
 * Set on <html> while the app's tab bar is shown, so what sticks to the bottom of a page sits
 * above it. Its own file: reading it must not pull in the whole tab bar module.
 */
export const TAB_BAR_HEIGHT_VAR = '--native-tab-bar-h';
